import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { rolesService } from "../../../services/rolesService";
import { AdminLayout } from "../../layout/AdminLayout";
import { toast } from "react-toastify";

export const RoleForm = () => {
	const [name, setName] = useState("");
	const [description, setDescription] = useState("");
	const [loading, setLoading] = useState(false);
	const [isNew, setIsNew] = useState(true);
	const { id } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		if (id && id !== "new") {
			setIsNew(false);
			loadRole(id);
		}
	}, [id]);

	const loadRole = async (roleId) => {
		try {
			const data = await rolesService.getById(roleId);
			setName(data.name);
			setDescription(data.description || "");
		} catch (error) {
			console.log("Error loading role:", error);
			toast.error("Failed to load role");
			navigate("/admin/roles");
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);

		try {
			const formData = { name, description };

			if (isNew) {
				await rolesService.create(formData);
				toast.success("Role created");
			} else {
				await rolesService.update(id, formData);
				toast.success("Role updated");
			}

			navigate("/admin/roles");
		} catch (error) {
			console.log("Error saving role:", error);
			toast.error("Failed to save role");
		} finally {
			setLoading(false);
		}
	};

	return (
		<AdminLayout>
			<div className="p-6">
				<div className="max-w-2xl mx-auto">
					<h1 className="text-3xl font-bold text-gray-800 mb-6">
						{isNew ? "Add Role" : "Edit Role"}
					</h1>

					<div className="bg-white rounded-lg shadow p-6">
						<form onSubmit={handleSubmit} className="space-y-6">
							<div>
								<label
									htmlFor="name"
									className="block text-sm font-medium text-gray-700 mb-2"
								>
									Role Name *
								</label>
								<input
									id="name"
									type="text"
									value={name}
									onChange={(e) => setName(e.target.value)}
									required
									className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
									placeholder="e.g., Software Engineer"
								/>
							</div>

							<div>
								<label
									htmlFor="description"
									className="block text-sm font-medium text-gray-700 mb-2"
								>
									Description
								</label>
								<textarea
									id="description"
									value={description}
									onChange={(e) => setDescription(e.target.value)}
									className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
									rows="4"
									placeholder="Role description"
								/>
							</div>

							<div className="flex gap-2">
								<button
									type="submit"
									disabled={loading}
									className="flex-1 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white font-medium py-2 rounded-lg transition"
								>
									{loading ? "Saving..." : "Save Role"}
								</button>
								<button
									type="button"
									onClick={() => navigate("/admin/roles")}
									className="flex-1 bg-gray-300 hover:bg-gray-400 text-gray-800 font-medium py-2 rounded-lg transition"
								>
									Cancel
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</AdminLayout>
	);
};
